import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
	Typography,
	CircularProgress,
	Box,
} from "@mui/material";
import CustomButton from "../../../components/ui/CustomButton";
import {
	getApprovalStats,
	getScenarios,
	setState,
	setValidate,
} from "../dashBoardSlice";
import React, { useEffect, useState } from "react";
import { sizes } from "../dashboardUtils";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../../components/ui/Alert";
import RunningPeriodStatus from "./RunningPeriodStatus";
import PendingAction from "./PendingAction";
import {
	checkRouteHistory,
	pushRoute,
	setSaveDashboardFormState,
} from "../../../store/globalSlice";

const selectHeight = sizes.h35;
// const orderStatusList = ["All", "Normal", "Blocked", "Blocked and Reviewed"];

export default function SearchForm() {
	const dispatch = useDispatch();
	const state = useSelector((state) => state.dashboard);
	const {
		drawerOpen,
		selectedCountry,
		selectedCountryID,
		countries,
		selectedCriticality,
		selectedCriticalityID,
		// selectedOrderStatus,
		scenario,
		scenarioCriticalityList,
		isLoading,
		approvalStats,
		validate,
	} = state;

	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: "",
	});

	const { saveDashboardFormStates } = useSelector((store) => store.global);

	function clearFormStates() {
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("selectedCountryID", ""));
		dispatch(setState("selectedCriticality", ""));
		dispatch(setState("selectedCriticalityID", ""));
		dispatch(setState("selectedOrderStatus", ""));
		dispatch(setState("scenario", ""));
	}

	function clearApprovalStats() {
		dispatch(setState("approvalStats", null));
	}

	function clearValidate() {
		dispatch(
			setValidate({
				countryValidated: false,
				criticalityValidated: false,
				orderStatusValidated: false,
			})
		);
	}

  function clearRunningPeriodStatus() {
    dispatch(setState("scenarios", []));
  }

	useEffect(() => {
		dispatch(pushRoute("dashboard"));

		dispatch(checkRouteHistory()).then((res) => {
			// console.log("expectedHistory", res.payload);
			// console.log("saveDashboardFormStates", saveDashboardFormStates);
			let expectedHistory = res.payload;
			let shouldNotClearPrevData = expectedHistory && saveDashboardFormStates;
			// console.log("shouldNotClearPrevData", shouldNotClearPrevData);
			if (shouldNotClearPrevData === false) {
				clearFormStates();
				clearApprovalStats();
        clearValidate();
        clearRunningPeriodStatus();
			}
		});

		dispatch(setSaveDashboardFormState(false));
	}, []);

	useEffect(() => {
		//Check if any of the dropdown are false and then set alertDisplay to false
		const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

		if (isAnyKeyValueFalse(validate)) {
			setAlert({ ...Alert, alertDisplay: false });
		}
	}, [validate]);

	const displayAlert = (showAlert, alertMessage) => {
		setAlert({
			alertSeverity: "warning",
			alertDisplay: `${showAlert}`,
			alertMessage: `${alertMessage}`,
		});
	};

	function setCountry(event) {
		const name = event.target.value;

		if (name) {
			dispatch(
				setValidate({
					...validate,
					countryValidated: true,
				})
			);
		}

    let countryID = null;

    if (name === "All") {
      countryID = 0;
    }
    else {
      countryID = countries.find(
        (country) => country.countryName === name
      ).countryID;
    }

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));
	}

	function setCriticality(event) {
		const name = event.target.value;
		let criticalityID = 0;
		if (name === "All") criticalityID = 0;
		else
			criticalityID = scenarioCriticalityList.find(
				(criticality) => criticality.scenarioCriticalityDesc === name
			).scenarioCriticalityID;

		if (name) {
			dispatch(
				setValidate({
					...validate,
					criticalityValidated: true,
				})
			);
		}

		dispatch(setState("selectedCriticality", name));
		dispatch(setState("selectedCriticalityID", criticalityID));
	}

	function setOrderStatus(event) {
		const status = event.target.value;

		if (status) {
			dispatch(
				setValidate({
					...validate,
					orderStatusValidated: true,
				})
			);
		}

		dispatch(setState("selectedOrderStatus", status));
	}

	function setScenario(event) {
		const scenario = event.target.value;
		dispatch(setState("scenario", scenario));
	}

	async function handleSearch() {
		if (!validate.countryValidated) {
			displayAlert(true, "Please select a Country");
		} else if (!validate.criticalityValidated) {
			displayAlert(true, "Please select a Criticality");
		} else {
			const getScenarioParams = {
				countryID: selectedCountryID,
				// status: selectedOrderStatus,
				// set status to null to align with "remove order status" change
				status: null,
				scenario: scenario,
				criticalityId: selectedCriticalityID,
			};

			const getApprovalStatsParams = {
				countryID: selectedCountryID,
			};

			try {
				await dispatch(getScenarios(getScenarioParams));
				await dispatch(getApprovalStats(getApprovalStatsParams));
			} catch {
				console.error("Error fetching the data");
			} finally {
				dispatch(setState("isLoading", false));
			}
		}
	}

	return (
		<>
			<Typography variant="subtitle1" sx={{ mt: 2, mb: 2 }}>
				Search for scenario
			</Typography>

			<Grid container columns={12} spacing={2}>
				<Grid item xs={2}>
					<FormControl fullWidth>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: "100%",
								color: "black.main",
								mt: 1,
							}}
							MenuProps={{
								disableScrollLock: true,
							}}
							onChange={setCountry}
						>
              <MenuItem value="All">{"All"}</MenuItem>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item xs={2}>
					<FormControl fullWidth>
						<InputLabel>Scenario Criticality</InputLabel>
						<Select
							value={selectedCriticality}
							label="Scenario Criticality"
							sx={{
								height: selectHeight,
								width: "100%",
								color: "black.main",
								mt: 1,
							}}
							MenuProps={{
								disableScrollLock: true,
							}}
							onChange={setCriticality}
						>
							<MenuItem key={0} value="All">
								All
							</MenuItem>
							{scenarioCriticalityList.map((criticality, index) => {
								return (
									<MenuItem
										key={criticality.scenarioCriticalityID}
										value={criticality.scenarioCriticalityDesc}
									>
										{criticality.scenarioCriticalityDesc}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item xs={3}>
					<TextField
						sx={{
							width: "100%",
						}}
						id="outlined-basic"
						label="Scenario"
						variant="outlined"
						size="small"
						value={scenario}
						onChange={setScenario}
						autoComplete="dashboard-scenario-name"
						InputProps={{ autoComplete: "dashboard-scenario-name" }}
						name="dashboard-scenario-name"
					/>
				</Grid>

				<Grid item xs={3}>
					<CustomButton
						sx={{
							height: "40px",
							width: "120px",
							bgcolor: "darkred.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							mt: 0,
							"&:hover": {
								bgcolor: "darkred.main",
								color: "white.main",
							},
						}}
						onClick={handleSearch}
					>
						Search
					</CustomButton>
				</Grid>
			</Grid>
			{alert.alertDisplay && (
				<Alert message={alert.alertMessage} severity={alert.alertSeverity} />
			)}

			<Paper
				elevation={2}
				sx={{
					width: drawerOpen ? "75%" : "100%",
					p: 2,
					borderRadius: 2,
					mt: 3,
					minHeight: "300px",
					display: "flex",
					alignItems: "flex-start",
					justifyContent: "space-between",
					position: "relative",
					gap: 2,
				}}
			>
				{isLoading && (
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "40%",
							transform: "translate(-50%,-50%)",
						}}
					>
						<CircularProgress />
					</Box>
				)}
				<Box sx={{ flexGrow: 1, minWidth: 0, overflow: "hidden" }}>
					<RunningPeriodStatus />
				</Box>

				<Box sx={{ minWidth: "280px", maxWidth: "350px", flexShrink: 0 }}>
					<Typography
						variant="subtitle1"
						sx={{ ml: 1, color: "#000000" }}
						gutterBottom
					>
						Pending Actions
					</Typography>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<PendingAction
								text={"Scenario Pending for Approval"}
								number={approvalStats?.scenarioCount ?? 0}
								link={
									selectedCountryID!=="" && approvalStats?.scenarioCount > 0
										? "/approval/scenario"
										: null
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<PendingAction
								text={"Quota Pending for Approval"}
								number={approvalStats?.quotaCount ?? 0}
								link={
									selectedCountryID!=="" && approvalStats?.quotaCount > 0
										? "/approval/quota"
										: null
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<PendingAction
								text={"Rejected Quota Pending for Resubmission"}
								number={approvalStats?.quotaRejectedCount ?? 0}
								link={
									selectedCountryID!== "" && approvalStats?.quotaRejectedCount > 0
										? "/approval/quota/Rejected"
										: null
								}
								period ={approvalStats?.quotaSubRejPeriod??null}
							/>
						</Grid>						
						<Grid item xs={12}>
							<PendingAction
								text={"Quota Modification Pending for Approval"}
								number={approvalStats?.quotaModificationsCount ?? 0}
								link={
									selectedCountryID!=="" &&
									approvalStats?.quotaModificationsCount > 0
										? "/approval/quota-modification"
										: null
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<PendingAction
								text={"Customers Approaching their Quota Limit"}
								number={approvalStats?.customerQuotaLimitCount ?? 0}
								link={
									selectedCountryID!=="" && selectedCountryID!==0 && 
									approvalStats?.customerQuotaLimitCount > 0
										? "/analyze"
										: null
								}
								category={"Customer"}
							/>
						</Grid>
						<Grid item xs={12}>
							<PendingAction
								text={"Products Approaching their Quota Limit"}
								number={approvalStats?.productQuotaLimitCount ?? 0}
								link={
									selectedCountryID!=="" && selectedCountryID!==0 && approvalStats?.productQuotaLimitCount > 0
										? "/analyze"
										: null
								}
								category={"Product"}
							/>
						</Grid>
					</Grid>
				</Box>
			</Paper>
		</>
	);
}
